import { indicesOf } from './indicesOf.ts'
import { mergeRange } from './mergeRange.ts'

export type Query = string | RegExp | (string | RegExp)[]

interface Chunk {
  isHighlighted: boolean
  text: string
  highlightIndex?: number
}

export function highlightChunks(text: string, queries: Query, { caseSensitive = false, diacriticsSensitive = false, wholeWordMatch = false } = {}) {
  if (typeof queries === 'string' || queries instanceof RegExp) {
    queries = [queries]
  }

  const matches: [number, number][] = []

  for (const query of queries) {
    matches.push(...indicesOf(text, query, { caseSensitive, diacriticsSensitive, wholeWordMatch }))
  }

  const highlights = mergeRange(matches)

  const chunks: Chunk[] = []
  let lastEnd = 0

  for (const index in highlights) {
    const [start, end] = highlights[index]

    if (lastEnd !== start) {
      chunks.push({
        isHighlighted: false,
        text: text.slice(lastEnd, start),
      })
    }
    chunks.push({
      isHighlighted: true,
      text: text.slice(start, end),
      highlightIndex: Number(index),
    })

    lastEnd = end
  }

  if (lastEnd !== text.length) {
    chunks.push({
      isHighlighted: false,
      text: text.slice(lastEnd),
    })
  }

  return chunks
}
